import React from 'react';
import { Helmet } from 'react-helmet-async';
import PatientSettingsClient from '../components/patients/PatientSettingsClient';

const PatientSettings: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Patient Settings - Doctif</title>
        <meta name="description" content="Configure patient form fields and settings" />
      </Helmet>
      <PatientSettingsClient />
    </>
  );
};

export default PatientSettings;
